import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as callRoutes } from './calls/routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as jabvoxKanbanRoutes } from './jabvox-kanban/routes';
import { routes as jabvoxProductsRoutes } from './jabvox-products/routes';
import { routes as jabvoxSmsRoutes } from './jabvox-sms/routes';
import { routes as jabvoxAiChatRoutes } from './jabvox-ai-chat/routes';
import { routes as jabvoxProvisioningChatRoutes } from './jabvox-provisioning-chat/routes';
import { routes as jabvoxDialerRoutes } from './jabvox-dialer/routes';
import { routes as jabvoxCalendarRoutes } from './jabvox-calendar/routes';
import { routes as jabvoxInternalChatRoutes } from './jabvox-internal-chat/routes';
import { routes as jabvoxReportsRoutes } from './jabvox-reports/routes';
import { routes as jabvoxCdrRoutes } from './jabvox-cdr/routes';
import { routes as jabvoxAudioAnalysisRoutes } from './jabvox-audio-analysis/routes';
import { routes as jabvoxAnalyticsRoutes } from './jabvox-analytics/routes';
import { routes as jabvoxTasksRoutes } from './jabvox-tasks/routes';
import { routes as jabvoxTicketsRoutes } from './jabvox-tickets/routes';
import { routes as jabvoxCustomDataRoutes } from './jabvox-custom-data/routes';
import { routes as jabvoxClinicaRoutes } from './jabvox-clinica/routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import OnboardingInboxSetup from './onboarding/InboxSetup.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...callRoutes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...jabvoxKanbanRoutes,
        ...jabvoxProductsRoutes,
        ...jabvoxSmsRoutes,
        ...jabvoxAiChatRoutes,
        ...jabvoxProvisioningChatRoutes,
        ...jabvoxDialerRoutes,
        ...jabvoxCalendarRoutes,
        ...jabvoxInternalChatRoutes,
        ...jabvoxReportsRoutes,
        ...jabvoxCdrRoutes,
        ...jabvoxAudioAnalysisRoutes,
        ...jabvoxAnalyticsRoutes,
        ...jabvoxTasksRoutes,
        ...jabvoxTicketsRoutes,
        ...jabvoxCustomDataRoutes,
        ...jabvoxClinicaRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/inbox-setup'),
      name: 'onboarding_inbox_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingInboxSetup,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
